import React, { useState } from 'react';
import  '../sections/Education.css';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import { FaRegChartBar,FaCode,FaUsers,FaMediumM,FaFileAlt,FaInstagram } from "react-icons/fa";


const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Work = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );



  return (
    <section class="ftco-section" style={{ marginTop: 50 }}>
      <div class="container">
        <div class="row justify-content-center mb-5 pb-5">
          <div
            class="col-md-7 text-center heading-section  fadeInUp reveal-from-bottom"
            data-reveal-delay="200"
          >
            <span>What i do</span>
            <h2 style={{ marginTop: 0 }}>Skills</h2>
          </div>
        </div>

        <div class="row">
          <div
            class="col-md-4 d-flex align-self-stretch    fadeInUp  reveal-from-bottom"
            data-reveal-delay="300"
          >
            <div class="media block-6 services p-3 py-4 d-block text-center">
              <div class="icon mb-3" style={{ marginLeft: "43%" }}>
                <span class="icon-bar-chart">
                  <FaRegChartBar />
                </span>
              </div>
              <div class="media-body">
                <h3 style={{ marginTop: 0 }} class="heading">
                  Data Analysis
                </h3>
                <h3 style={{ marginTop: 0 }} class="heading">
                  Data Visualization
                </h3>
                <h3 style={{ marginTop: 0 }} class="heading">
                  Data Science
                </h3>
              </div>
            </div>
          </div>
          <div
            class="col-md-4 d-flex align-self-stretch    fadeInUp   reveal-from-bottom"
            data-reveal-delay="300"
          >
            <div class="media block-6 services p-3 py-4 d-block text-center">
              <div class="icon mb-3" style={{ marginLeft: "43%" }}>
                <span class="icon-code">
                  <FaCode />
                </span>
              </div>
              <div class="media-body">
                <h3 style={{ marginTop: 0 }} class="heading">
                  Frontend - HTML, CSS, JavaScript, ReactJS
                </h3>
                <h3 style={{ marginTop: 0 }} class="heading">
                  Backend - NodeJS, Python(Flask), .NET
                </h3>
                <h3 style={{ marginTop: 0 }} class="heading">
                  Database - Postgres, MongoDB, MSSQL
                </h3>
              </div>
            </div>
          </div>
          <div
            class="col-md-4 d-flex align-self-stretch    fadeInUp   reveal-from-bottom"
            data-reveal-delay="300"
          >
            <div class="media block-6 services p-3 py-4 d-block text-center">
              <div class="icon mb-3" style={{ marginLeft: "43%" }}>
                <span>
                  <FaUsers />
                </span>
              </div>
              <div class="media-body">
                <h3 style={{ marginTop: 0 }} class="heading">
                  Community Development
                </h3>
                <h3 style={{ marginTop: 0 }} class="heading">
                  Leadership
                </h3>
                <h3 style={{ marginTop: 0 }} class="heading">
                  Team Management
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Work;